import type { ActivityResource } from "../types";

const escape = (value: string) => value.replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);

/** Authored content is text, including when printed; never interpret it as HTML. */
export function resourcePrintHtml(resource: Pick<ActivityResource, "title" | "body" | "note">) {
  return `<!doctype html><html><head><meta charset="utf-8"><title>${escape(resource.title)}</title>
  <style>@page{size:A4;margin:18mm}body{font:12pt/1.65 Georgia,serif;color:#172e40;max-width:180mm;margin:auto}h1{font:700 21pt/1.2 sans-serif}p{white-space:pre-wrap;overflow-wrap:anywhere}small{font:10pt sans-serif}footer{margin-top:2em;border-top:1px solid #bbb;padding-top:1em}</style></head>
  <body><small>Al Noor Homeschool</small><h1 dir="auto">${escape(resource.title)}</h1>
  <p dir="auto">${escape(resource.body ?? "")}</p>${resource.note ? `<footer dir="auto">${escape(resource.note)}</footer>` : ""}</body></html>`;
}

export function printResource(resource: ActivityResource) {
  const frame = document.createElement("iframe");
  frame.title = resource.title;
  frame.style.cssText = "position:fixed;width:0;height:0;border:0;bottom:0;right:0";
  frame.onload = () => {
    const view = frame.contentWindow;
    if (!view) { frame.remove(); return; }
    view.addEventListener("afterprint", () => frame.remove(), { once: true });
    view.focus();
    view.print();
    // Some mobile browsers do not emit afterprint.
    window.setTimeout(() => frame.remove(), 300_000);
  };
  frame.srcdoc = resourcePrintHtml(resource);
  document.body.appendChild(frame);
}
